import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import BorderSides from "%/dynamic-components/render-engine/options/border-options/border-sides";

export default class BorderOptions extends BaseOptionsBundle {

  optionTitle = "Border";
  static optionClassName = "i-dynamic-border";

  constructor(values = {}) {
    super(values, [
      BorderSides,
    ]);
  }
}
